package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.contentOrNull
import kotlinx.serialization.json.jsonPrimitive

@Serializable
data class SchoolStaffResponse(
    @SerialName("school_id")
    val schoolId: String? = null,
    @SerialName("user_id")
    val userId: String? = null,
    @SerialName("employee_id")
    val employeeId: String? = null,
    val name: String? = null,
    @SerialName("role_title")
    val roleTitle: String? = null,
    @SerialName("auth_role")
    val authRole: String? = null,
    val gender: String? = null,
    val mobile: String? = null,
    val email: String? = null,
    @SerialName("custom_attributes")
    val customAttributes: Map<String, JsonElement>? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null,
    @SerialName("push_notification_enabled")
    val pushNotificationEnabled: Boolean? = null,
    @SerialName("email_notification_enabled")
    val emailNotificationEnabled: Boolean? = null,
    @SerialName("profile_image_url")
    val profileImageUrl: String? = null,
    val id: String? = null,
    @SerialName("created_at")
    val createdAt: String? = null,
    @SerialName("created_by_id")
    val createdById: String? = null,
    @SerialName("updated_at")
    val updatedAt: String? = null,
    @SerialName("updated_by_id")
    val updatedById: String? = null
) {
    val resolvedMobile: String
        get() {
            val customMobile = customAttributes.orEmpty()["mobile"]
                ?.let { element -> runCatching { element.jsonPrimitive.contentOrNull }.getOrNull() }
                .orEmpty()
            return mobile.orEmpty().trim().ifBlank { customMobile }
        }
}

@Serializable
data class TeachingAssignmentDetailResponse(
    val id: String? = null,
    @SerialName("staff_id") val staffId: String? = null,
    @SerialName("class_section_id") val classSectionId: String? = null,
    @SerialName("class_name") val className: String? = null,
    @SerialName("section_name") val sectionName: String? = null,
    @SerialName("subject_id") val subjectId: String? = null,
    @SerialName("subject_name") val subjectName: String? = null,
    @SerialName("subject_short_code") val subjectShortCode: String? = null,
    @SerialName("is_active") val isActive: Boolean? = null
)

@Serializable
data class ClassTeacherAssignmentDetailResponse(
    val id: String? = null,
    @SerialName("staff_id") val staffId: String? = null,
    @SerialName("class_section_id") val classSectionId: String? = null,
    @SerialName("class_name") val className: String? = null,
    @SerialName("section_name") val sectionName: String? = null,
    @SerialName("is_active") val isActive: Boolean? = null
)

@Serializable
data class SchoolStaffWithAssignmentsResponse(
    val id: String? = null,
    @SerialName("school_id") val schoolId: String? = null,
    @SerialName("user_id") val userId: String? = null,
    @SerialName("employee_id") val employeeId: String? = null,
    val name: String? = null,
    @SerialName("role_title") val roleTitle: String? = null,
    @SerialName("auth_role") val authRole: String? = null,
    val gender: String? = null,
    @SerialName("custom_attributes") val customAttributes: Map<String, JsonElement>? = null,
    @SerialName("is_active") val isActive: Boolean? = null,
    val mobile: String? = null,
    val email: String? = null,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("updated_at") val updatedAt: String? = null,
    @SerialName("teaching_assignments") val teachingAssignments: List<TeachingAssignmentDetailResponse>? = null,
    @SerialName("class_teacher_assignments") val classTeacherAssignments: List<ClassTeacherAssignmentDetailResponse>? = null
) {
    fun toSchoolStaffResponse(): SchoolStaffResponse = SchoolStaffResponse(
        schoolId = schoolId,
        userId = userId,
        employeeId = employeeId,
        name = name,
        roleTitle = roleTitle,
        authRole = authRole,
        gender = gender,
        mobile = mobile,
        email = email,
        customAttributes = customAttributes,
        isActive = isActive,
        id = id,
        createdAt = createdAt,
        updatedAt = updatedAt
    )
}
